import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const ButtonWrapper = styled('div')`
  padding-bottom: 15px;

  [class*='button-wrapper'] {
    width: 130px;
    font-size: 13px !important;

    span {
      font-family: var(--ph-font-family-lato-bold) !important;
    }
  }
`;

const DetailedFindingText = styled('p')`
  font-family: var(--ph-font-family-lato-regular);
  font-size: var(--ph-heading-five);
  color: var(--dark-blue);
`;

const Collapsable = styled('div')`
  padding-top: 5px;
  cursor: pointer;
  background: var(--ph-gray-5);
`;

const CollapseIcon = styled(Svg)`
  height: 15px;
  width: 15px;

  &:hover {
    opacity: 1;
    background: var(--grayish-blue);
  }
`;

const CollapsableWrapper = styled('button')`
  cursor: default;
  background-color: transparent !important;
`;

const Content = styled('div')`
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-size: 11px;
  color: var(--dark-blue);
  padding-top: 10px;
`;

const DetailWrapper = styled('div')`
  [class*='editableField'] {
    padding: 6px;

    textarea {
      line-height: 1.5 !important;
      border: 2px solid;
      resize: none;
      font-size: 11px;
      padding: 2px 7px;
      &::placeholder {
        font-style: italic;
      }
    }
  }
`;

const DetailsWrapper = styled('div')`
  padding-top: 10px;
`;

const ExpandIcon = styled(Svg)`
cursor: pointer;
height: 15px;
width: 15px;

&:hover {
  opacity: 1;
  background: var(--grayish-blue);
}
`;

const ErrorWrapper = styled('p')`
  padding-left: 20px;
  color: var(--ph-red-500);
`;

const FindingStatus = styled('div')`
  display: inline-block;
  border-radius: 4px;
  height: 30px;
  padding: 5px 10px;
  text-align: center;
  position: relative;
  top: 15%;
  font-size: 11px;
  font-family: var(--ph-font-family-source-sans-pro-semibold);

  &[class*='bg-gray'] {
    background-color: var(--gray);
    color: var(--white);
  }

  &[class*='bg-green'] {
    background-color: var(--lime-green);
    color: var(--white); 
  }

  &[class*='bg-aqua-100'] {
    background-color: var(--ph-aqua-100);
  }

  &[class*='bg-mint'] {
    background-color: var(--cyan-green);
  }

  &[class*='text-navy-100'] {
    color: var(--dark-blue); 
  }
`;

const Heading = styled('h3')`
  font-family: var(--ph-font-family-lato-bold);
  color: var(--dark-blue);
  font-size: var(--ph-heading-size);
  padding-top: 7px;
`;

const ImprovementHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  background: rgba(15, 18, 50, 0.1) 0% 0%;
`;

const ImprovementSection = styled('section')`
  box-shadow: 0px 1px 2px #00000026;
  border: 0.5px solid var(--dark-blue);

  [class*='editableText'] {
    &:hover {
      cursor: pointer;
      padding-left: 10px;
      padding-right: 10px;
      background: var(--light-grayish-blue);
      margin-left: 5px;
      margin-right: 5px;
    }
  }

  [class*='pl-15'] {
    padding-left: 15px;
  }
  [class*='pr-15'] {
    padding-right: 15px;
  }
  [class*='pt-9'] {
    padding-top: 9px;
  }
  [class*='collapsable'] {
    padding-top: 5px;
  }

  [class*='cursor-default'] {
    cursor: default;
  }

  [class*='cursor-pointer'] {
    cursor: pointer;
  }
  
  [class*='bg-black']{
    background-color: var(--dark-black);
    color: var(--white);
  }
  [class*='bg-extreme']{
    background-color: var(--ph-red-500);
    color: var(--white);
  }
  [class*='bg-high']{
    background-color: var(--high-orange);
    color: var(--white);
  }
  [class*='bg-medium']{
    background-color: var(--medium-yellow);
    color: var(--dark-blue);
  }
  [class*='bg-midGrey']{
    background-color: var(--ph-gray-250);
    color: var(--dark-blue);
  }
`;

const InfoWrapper = styled('div')`
  background: var(--light-grayish-blue) 0% 0%;
  display: flex;
  justify-content: space-between;
`;

const Label = styled('label')`
  font-family: var(--ph-font-family-lato-bold);
  font-size: 11px;
  color: var(--dark-blue);
`;

const LeftSection = styled('div')`
  display: flex;
`;

const List = styled('ul')`
  font-size: 11px;
  margin-bottom: 0px !important;
  padding: 5px 0px;

  :last-child {
    border-right: none;
  }
`;

const ListItem = styled('li')`
  border-right: 0.5px solid var(--dark-blue);
  padding: 0px 25px;
  display: inline-block;
  margin: 5px 0px;
`;

const Text = styled('p')`
  font-family: var(--ph-font-family-lato-regular);
  font-size: 11px;
  padding-top: 4px
`;

const SeverityDiv = styled('div')`
  padding: 5px 20px;
  display: inline-block;
  font-family: var(--ph-font-family-source-sans-pro-semibold);
  font-size: 11px;
  background-color: var(--black-900);
  color: var(--white);  
  text-align: center;
  height: 28px;
  position: relative;
  top: 30%;

  &[class*='bg-midGray'] {
    background-color: var(--ph-gray-250);
  }
`;

const ToggleWrapper = styled('div')`
  [class*='collapsable'] {
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.5s ease-in-out;
  }

  [class*='expanded'] {
    max-height: 1000px;
    transition: max-height 0.7s ease-in-out;
  }
`;

export default {
  ButtonWrapper,
  Collapsable,
  CollapseIcon,
  CollapsableWrapper,
  Content,
  DetailWrapper,
  DetailsWrapper,
  DetailedFindingText,
  ErrorWrapper,
  ExpandIcon,
  FindingStatus,
  Heading,
  ImprovementHeader,
  ImprovementSection,
  InfoWrapper,
  Label,
  LeftSection,
  List,
  ListItem,
  SeverityDiv,
  Text,
  ToggleWrapper,
}
